import { Component, OnInit, inject } from '@angular/core';
import { CommonFormComponent } from '@ntap/common';
import {
  BackendDataSourceService,
  ItemViewProviderDirective
} from '@ntap/core';

import { mergeMap, Observable, of, tap } from 'rxjs';
import { SpremisteLocationsNodeService } from './spremisteLocationsNodeService';

type LocationObjectProp = {
  label: string;
  data: number | string;
  children?: LocationObjectProp[];
};
@Component({
  selector: 'app-location-from-storage',
  templateUrl: './location-from-storage.component.html',
  styleUrls: ['./location-from-storage.component.scss'],
  providers: [{ provide: SpremisteLocationsNodeService }]
})
export class LocationFromStorageComponent
  extends CommonFormComponent
  implements OnInit
{
  onLazyLoad() {
    alert('lazy');
  }
  itemViewProviderDirective = inject(ItemViewProviderDirective);
  backendService = inject(BackendDataSourceService);
  spremisteLocationsNodeService = inject(SpremisteLocationsNodeService);
  locationsArray$: Observable<any>;
  selectedNodes: LocationObjectProp | null;

  override doChangedInputParam(): void {
    this.initComponentData(this.inputParam);
    this.formControl =
      this.formService.getFormControl(this.formControlName) || this.formControl;
    if (this.inputParam.itemValue !== undefined) {
      this.formControl.setValue(this.inputParam.itemValue);
      this.currentValue = this.inputParam.itemValue;
    }
    this.formControlInitialized = true;
    this.formControl.markAsPristine();
  }

  ngOnInit() {
    this.addSubscription(
      this.itemViewProviderDirective.item$
        .pipe(
          mergeMap((item) => {
            //GET ARRAY OF LOCATIONS FROM spremisteLocationsNodeService
            this.locationsArray$ =
              this.spremisteLocationsNodeService.getSpremisteLocations(item);

            //IF LOCATION ALREADY EXISTS SET TREESELECT COMPONENT selectedNodes VALUE TO locationsArray$ OBJECT THAT MATCHES ID
            const locationValueExists = this.formControl.value != null;
            const existingLocationId: number = this.formControl.value;

            if (locationValueExists) {
              return this.locationsArray$.pipe(
                tap((locationsArray: LocationObjectProp[]) => {
                  this.selectedNodes = findObjectOfExistingLocation(
                    locationsArray,
                    existingLocationId
                  );
                })
              );
            }
            return of({});
          })
        )
        .subscribe()
    );
  }

  onNodeSelect(event: any) {
    //SET formControl VALUE ON TREESELECT COMPONENT CHANGE
    this.setValue(event.node.data);
  }

  clearSelection() {
    this.selectedNodes = null;
    this.formControl.setValue(null);
    this.formControl.markAsDirty();
  }
}

function findObjectOfExistingLocation(
  locations: LocationObjectProp[],
  existingLocationId: number
): LocationObjectProp | null {
  for (const location of locations) {
    if (location.data === existingLocationId) {
      return location;
    }
    if (location.children) {
      const found = findObjectOfExistingLocation(
        location.children,
        existingLocationId
      );
      if (found) {
        return found;
      }
    }
  }
  return null;
}
